import Button from '@ui/components/Button/Button';
import Card from '@ui/components/Card/Card';
import CardBody from '@ui/components/Card/components/CardBody/CardBody';
import CardImage from '@ui/components/Card/components/CardImage/CardImage';
import Content from '@ui/components/Content/Content';
import { getHeadingTag } from '@ui/utils';
import Heading from '@ui/components/Heading/Heading';
import Link from '@ui/components/Link/Link';
import styles from './Final.module.scss';
import React from 'react';
import PropTypes from 'prop-types';

const Final = ({
  finalContent,
  finalImage,
  finalLink,
  finalSubtitle,
  headingLevel,
}) => (
  <Card className={styles.card}>
    {!!finalImage && (
      <CardImage
        aspectRatio={0.49}
        image={{
          ...finalImage,
          ...{
            src: finalImage.url,
            alt: finalImage.alt || finalImage.title,
          },
        }}
      />
    )}
    <CardBody>
      <Heading as={getHeadingTag(headingLevel)} size="h4">
        Vielen Dank für Ihre Teilnahme!
      </Heading>
      {!!finalContent && <Content withParser>{finalContent}</Content>}
      {!!finalSubtitle && (
        <Content className={styles.finalSubtitle} withParser>
          {finalSubtitle}
        </Content>
      )}
      {!!finalLink && (
        <Button
          className={styles.button}
          isElevated
          render={<Link target={finalLink.target} to={finalLink.url} />}
        >
          {finalLink.title}
        </Button>
      )}
    </CardBody>
  </Card>
);

Final.propTypes = {
  finalContent: PropTypes.string,
  finalImage: PropTypes.shape({
    alt: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  finalLink: PropTypes.shape({
    target: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  finalSubtitle: PropTypes.string,
  headingLevel: PropTypes.number,
};

export default Final;
